export const environment = {
  production: true,
  baseUrl: 'https://moval.techkrate.com/backend/'
};
